import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getFunctions } from 'firebase/functions'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

const firebaseApp = initializeApp(firebaseConfig)
const auth = getAuth(firebaseApp)
const firestore = getFirestore(firebaseApp)
const storage = getStorage(firebaseApp)
const functions = getFunctions(firebaseApp)
const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY

export const initializeMessaging = async () => {
  if (typeof window === 'undefined' || typeof Notification === 'undefined') {
    return null
  }

  try {
    const { getMessaging, getToken } = await import('firebase/messaging')
    const messaging = getMessaging(firebaseApp)
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      const token = await getToken(messaging, { vapidKey })
      console.log('FCM Token:', token)
      return token
    } else {
      console.log('알림 권한이 거부되었습니다.')
      return null
    }
  } catch (err) {
    console.error('FCM 토큰 가져오기 실패:', err)
    return null
  }
}

export { firebaseApp, auth, firestore, storage, functions }
